export const middleware = (dispatch, state) => input =>
  input instanceof Function ? input(dispatch, state) : dispatch(input);
